import { Component, Input } from "@angular/core"

@Component({
    selector: "app-twitter-share",
    templateUrl: "./twitter-share.component.html",
    styleUrls: ["./twitter-share.component.scss"],
    standalone: false,
})
export class TwitterShareComponent {
    @Input() text: string = ""

    public share() {
        window.open(
            `https://twitter.com/share?ref_src=twsrc%5Etfw&text=${encodeURIComponent(this.text)}`,
            "twitter-share-dialog",
            "width=600,height=400"
        )
        return false
    }
}
